/*
//import {connect} from "react-redux"
import {Link, NavLink, useLocation, useNavigate} from "react-router-dom";
import React, {useContext, useEffect, useState} from "react";
import {Nav, Navbar, NavDropdown} from "react-bootstrap";
import {useSelector} from "react-redux";
import {GetRequest} from "../../../../configs/request";
import Logo from '@assets/images/logo/logo1.png';
import {AboutIcon, ArticleIcon, ContactIcon, HomeIcon, ProductIcon , GalleryIcon} from "./MenuItem";
import {DETAILS} from "@assets/data/config/storeConfig";
import Arrow from "@assets/images/svg/Polygon.svg"
import {Category} from "../../../../utility/context/ProductCategoryProvider";
import {AiOutlineMail} from "react-icons/ai";
import {Mail} from "react-feather";
import {RiSearch2Line} from "react-icons/ri";
import {AiOutlineLeft} from 'react-icons/ai'


const MENU_ITEMS = [
    {
        route: '/',
        image: HomeIcon,
        title: 'صفحه اصلی',
    },
    // {
    //     route: '/products',
    //     image: ProductIcon,
    //     title: 'محصولات',
    //     Children: [
    //         {
    //             title: 'محصول',
    //         },
    //         {
    //             title: 'محصول',
    //         },
    //         {
    //             title: 'محصول',
    //         },
    //     ],
    // },
    {
        route: '/products',
        image: ProductIcon,
        title: 'محصولات',
    },
    {
        route: '/gallery',
        image: GalleryIcon,
        title: 'گالری',
    },
    {
        route: '/contact-us',
        image: ContactIcon,
        title: 'تماس با ما',
    },
    {
        route: '/about-us',
        image: AboutIcon,
        title: 'درباره ما',
    },
    {
        route: '/articles',
        image: ArticleIcon,
        title: 'مقالات',
    },
    {
        route: '/rules',
        image: ArticleIcon,
        title: 'قوانین و مقررات',
    },
    {
        route: '/questions',
        image: ArticleIcon,
        title: 'سوالات متداول',
    }
];
const MobileMenu = ({ toggleMenu} ) => {
    const UI = useSelector(state => state.UI);
    const [menu, setMenu] = useState(localStorage.getItem('menu') ? JSON.parse(localStorage.getItem('menu')) : []);

    const menuUpdate = useSelector(state => state.UI.menu);
    const {pathname} = useLocation();
    const auth = useSelector(state => state.auth);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState("")
    const [currentPage, setCurrentPage] = useState(1)
    const navigate = useNavigate()
    const data = useContext(Category)

    useEffect(() => {
        if (UI.menu)
            setMenu(UI.menu)
    }, [UI])

    const toggleDropdown = () => setDropdownOpen(prevState => !prevState);
    const onMouseEnter = () => setDropdownOpen(true);
    const onMouseLeave = () => setDropdownOpen(false);

    const handleSearchTermChange = (e) => {
        const searchTerm = e.target.value;
        setSearchTerm(searchTerm);
        setCurrentPage(1);
    };

    const handleKeyDown = (e) => {
        if(e.key === 'Enter'){
            handelSearch(e)
        }
    }

    const handelSearch = (e) => {
        navigate("/products?s=" + searchTerm);
        setSearchTerm("")
    }

    return (
        <>
            <Navbar className="d-flex flex-column menu-phone menu" >
                <div className='menu-title'>
                    <h4>منو</h4>
                </div>

                <div className="d-flex align-items-center justify-content-center search-phone ">
                    <div className='search-menu-phone d-flex'>
                        <input
                            className="search-Input "
                            placeholder="جست و جوی محصول..."
                            onChange={handleSearchTermChange}
                            onKeyDown={handleKeyDown}
                            type="search"
                            name="search"
                            value={searchTerm}/>
                        <div className='svg-input'>
                            {/!*<button  show={dropdownOpen}*!/}
                            {/!*         onClick={toggleDropdown}><RiSearch2Line/></button>*!/}
                            <RiSearch2Line  onClick={handelSearch}/>
                        </div>
                    </div>
                </div>

                {/!*<div className="d-flex ">*!/}
                {/!*{*!/}
                {/!*    DETAILS.socialMedia.map((socialMedium, index) => socialMedium.isPrimary &&*!/}
                {/!*            <a key={index}*!/}
                {/!*               href={socialMedium.link}*!/}
                {/!*               rel="noreferrer"*!/}
                {/!*               target="_blank"*!/}
                {/!*               className="my-auto "*!/}
                {/!*               title={socialMedium.title}*!/}

                {/!*            >*!/}
                {/!*                <div className="header-contact-icon ">*!/}
                {/!*                    {socialMedium.icon}*!/}
                {/!*                </div>*!/}
                {/!*            </a>*!/}
                {/!*    )*!/}
                {/!*}*!/}
                {/!*</div>*!/}
            <Nav className="navbar">
                {menu?.map((menuItem, index) => {
                    if (menuItem.Children) {
                        return (
                            <div>
                                    <button type="button" className="navbar-Item btn font-medium-3 mr-1 d-flex align-items-center pl-0"
                                            show={dropdownOpen}
                                            onClick={toggleDropdown}>
                                        {/!*<img src={menuItem.image} className="mr-1" />*!/}
                                        <Nav.Link onClick={()=> navigate('/products')}>{menuItem.title}</Nav.Link>
                                        {/!*<img src={Arrow} className='pl-1'/>*!/}
                                    </button>
                                    {/!*<span className={dropdownOpen === true ? 'd-inline' : 'd-none'}>*!/}
                                    {/!*    <div className="sub-menu-phone ">*!/}
                                    {/!*           /!*{data?.map((item, i) => (*!/!*!/}
                                    {/!*           /!*    <Nav.Link key={i} className=" border-none"  onClick={()=> navigate(`/products/category/${item.slug}`)} >{item.title}</Nav.Link>*!/!*!/}
                                    {/!*           /!*))}*!/!*!/}
                                    {/!*    </div>*!/}
                                    {/!*</span>*!/}
                                {/!*<NavDropdown*!/}
                                {/!*    key={index}*!/}
                                {/!*    onMouseEnter={onMouseEnter}*!/}
                                {/!*    onMouseLeave={onMouseLeave}*!/}
                                {/!*    show={dropdownOpen}*!/}
                                {/!*    onToggle={toggleDropdown}*!/}
                                {/!*    drop="center"*!/}
                                {/!*    align="end"*!/}
                                {/!*{*!/}
                                {/!*    {Categories?.map((item, i) => (*!/}
                                {/!*        <Nav.Link key={i} className="p-1 m-1 border-none" href={`/products/category/${item.slug}`}>{item.title}</Nav.Link>*!/!*!/}
                                {/!*    ))}*!/}

                                {/!*</NavDropdown>*!/}
                            </div>
                        );
                    }
                    return (
                        <Nav.Link
                            key={index}
                            className={pathname === menuItem.url ? 'active ' : 'navbar-Item'}
                            onClick={() => {
                                toggleMenu()
                                navigate(menuItem.url)
                            }
                            }>
                            {/!*<img src={menuItem.image} className="mr-1" />*!/}
                            <AiOutlineLeft/>
                            {menuItem.title}
                        </Nav.Link>
                    );
                })}

            </Nav>
                <div className="border-bottom-menu"></div>
                <img src={Logo} width={'70px'}/>
        </Navbar>

        </>
    )
}

export default MobileMenu;

*/








import React, {useEffect, useState} from "react";
import {Collapse} from "reactstrap";
import classnames from "classnames";
import {useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";

const Limit = true;
const LimitLevels = 4;
const MobileMenu = ({toggleMenu}) => {
    const navigate = useNavigate();
    const UI = useSelector(state => state.UI);
    const [menu, setMenu] = useState(localStorage.getItem('menu') ? JSON.parse(localStorage.getItem('menu')) : []);

    const menuUpdate = useSelector(state => state.UI.menu);
    const MenuType = {
        Category: 0,
        Link: 1
    }
    const MenuOpen = {
        InTab: 0,
        NewTab: 1
    }
    const MenuStatus = {
        Active: 0,
        UnClickable: 1,
        Invisible: 2
    }

    useEffect(() => {
        if (menuUpdate) {
            setMenu(menuUpdate);
        }
    }, [menuUpdate]);

    const toggle = (menu_id) => {
        let index = menu.findIndex(f => f.id === menu_id);
        if (index >= 0) menu[index].collapse = !menu[index].collapse;
        setMenu([...menu]);
    }

    const hasChild = (id) => {
        return menu.filter(f => f.parentId === id).length > 0
    }

    const isValidUrl = urlString => {
        let url;
        try {
            url = new URL(urlString);
        } catch (e) {
            return false;
        }
        return url.protocol === "http:" || url.protocol === "https:";
    }

    const handleUrl = (item) => {

        switch (parseInt(item.type)) {
            case MenuType.Category:
                toggleMenu();
                navigate(`/products-categories/${item.category.value}`)
                break;
            case MenuType.Link:
                if (isValidUrl(item.url)) {
                    switch (parseInt(item.openIn)) {
                        case MenuOpen.InTab:
                            window.location = item.url;
                            break;
                        case MenuOpen.NewTab:
                            toggleMenu();
                            window.open(item.url, "_blank");
                            break;
                    }
                } else {
                    toggleMenu();
                    navigate(item.url)
                }
                break;
        }
    }

    const renderSubMenu = (parent_id = "main", limit = 1) => {
        return menu.filter((item) => item.parentId === parent_id).sort((a, b) => a.index - b.index).map((menu_item, index) => {
            console.log(menu_item)
            if (menu_item.status !== MenuStatus.Invisible)
                return (
                    <div key={index} className={classnames("", {
                        "menu-mobile-main": parent_id === "main",
                    })}>

                        <div className={classnames("menu-mobile-item", {
                            'lock': menu_item.status === MenuStatus.UnClickable
                        })}>
                            <div className={classnames("title", {'Open': menu_item.collapse})}
                                 onClick={menu_item.status === MenuStatus.UnClickable ? () => {
                                 } : () => handleUrl(menu_item)}>
                                {menu_item.title}
                            </div>
                            {(menu_item.canHaveChild && hasChild(menu_item.id)) &&
                                <div className="icon" onClick={() => toggle(menu_item.id)}>
                                    <i className={classnames("my-auto float-right", {
                                        'fa fa-angle-left': !menu_item.collapse,
                                        'fa fa-angle-left open': menu_item.collapse
                                    })}
                                    > </i>
                                </div>
                            }
                        </div>

                        {(menu_item.canHaveChild && hasChild(menu_item.id)) &&
                            <Collapse className={classnames("menu-mobile-bg m-0")} isOpen={menu_item.collapse}>
                                {Limit ?
                                    limit < LimitLevels &&
                                    renderSubMenu(menu_item.id, (limit + 1))
                                    :
                                    renderSubMenu(menu_item.id)
                                }
                            </Collapse>
                        }
                    </div>
                )
        });
    };

    return menu?.length > 0 && renderSubMenu()
};

export default MobileMenu;
